import 'vite/modulepreload-polyfill'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { createVfm } from 'vue-final-modal'
import VueGridLayout from 'vue-grid-layout'
import Toast, { POSITION } from 'vue-toastification'
import * as Sentry from '@sentry/vue'
import { VTooltip } from 'floating-vue'
import router from '@helm/plugins/router'
import { vueQueryOptions } from '@helm/plugins/query'
import '@helm/plugins/chartjs'
import App from '@helm/App.vue'
import ENV from '@/constants/env'
import { SproutKitPlugin } from '@tithely/sproutkit-vue'
import 'floating-vue/dist/style.css'
import '@helm/assets/tooltip.css'
import 'vue-final-modal/style.css'
import '@/assets/fonts'
import '@/assets/style/style.scss'
import '@/assets/style/toast.scss'
import 'reflect-metadata' // Required for class-transformer (https://github.com/typestack/class-transformer#nodejs)

const app = createApp(App)

const vfm = createVfm()

if (ENV.sentryDSN) {
    Sentry.init({
        app,
        dsn: ENV.sentryDSN,
        environment: ENV.environment
    })
}

// Plugins
app.use(createPinia())
app.use(createHead())
app.use(router)
app.use(VueQueryPlugin, vueQueryOptions)
app.use(vfm)
app.use(Toast, {
    position: POSITION.BOTTOM_RIGHT
})
app.use(SproutKitPlugin)
// vue-grid-layout only exports a plugin install function (registers `grid-layout`/`grid-item`
// as global components) - there's no `GridLayout`/`GridItem` to import and use locally.
app.use(VueGridLayout)

// Directives
app.directive('tooltip', VTooltip)

// Load App
app.mount(`#app`)
